import { useNotify, useRecordContext, useRefresh } from "react-admin";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import ConfirmModal from "server/components/Modals/ConfirmModal";
import { erasmusRequests } from "api/erasmusApi";
import dataProvider from "server/dataProvider";

const CompleteMobilityDialog = ({ label = "Приключи мобилност" }) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record || record.isCompleted) return null;

  const handleConfirm = async () => {
    await dataProvider.customRequest(erasmusRequests.completeOutgoingEmployee(record.id), null, "PUT");

    notify("Мобилността е приключена успешно.", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Приключване на мобилност"
      message="Сигурни ли сте, че искате да приключите мобилността? Това е предпоставка за издаване на сертификатите."
      onConfirm={handleConfirm}
      titleButton={label}
      startIcon={<CheckCircleIcon />}
      saveTitle="Приключи"
      closeTitle="Откажи"
    />
  );
};

export default CompleteMobilityDialog;
